export default function EyeIcon() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 3.1665C4.57941 3.1665 1.6002 5.3149 0 8.4999C1.6002 11.6855 4.57941 13.8333 8 13.8333C11.4206 13.8333 14.3998 11.6855 16 8.4999C14.3998 5.3149 11.4206 3.1665 8 3.1665ZM8 11.8333C6.15879 11.8333 4.6666 10.3411 4.6666 8.4999C4.6666 6.65869 6.15879 5.1665 8 5.1665C9.84121 5.1665 11.3334 6.65869 11.3334 8.4999C11.3334 10.3411 9.84121 11.8333 8 11.8333Z"
        fill="currentColor"
      />
      <path
        d="M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
